import { useReducer } from 'react'
import type { FlightSearchWidgetState } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'
import flightSearchWidgetStateReducer, { initialState as FLIGHT_SEARCH_INITIAL_STATE } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'

function useFlightSearchContext(initialState: FlightSearchWidgetState = FLIGHT_SEARCH_INITIAL_STATE) {
  const [flightSearchState, flightSearchDispatch] = useReducer(flightSearchWidgetStateReducer, initialState)

  return { flightSearchState, flightSearchDispatch }
}

export default useFlightSearchContext
